import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import OTPVerificationForm from "./OtpInput/OtpVerificationForm";

function GlobalModal({ isModalOpen, onCancel, keepSignedIn, data, name = "" }) {
  const { t } = useTranslation();

  const isEmirates = data?.selectedCountry === "ae";

  return (
    <Modal
      className={name}
      centered
      title={
        !isEmirates
          ? t("auth.verifyOTP")
          : `${t("auth.verifyOTP")} - (${t("auth.weSent")})`
      }
      open={isModalOpen}
      footer={null}
      closable
      onCancel={onCancel}
      maskClosable={false}
    >
      <OTPVerificationForm
        keepSignedIn={keepSignedIn}
        data={data}
        onCancel={onCancel}
        isEmirates={isEmirates}
      />
    </Modal>
  );
}

export default GlobalModal;
